import SpendsTypes from './components/SpendsTypes';

export default SpendsTypes;
